import { strCode } from "../localizations/strCode";

export const appsConfigurationOptions = [
  {
    id: 0,
    title: strCode.GENERAL_TITLE
  },
  {
    id: 1,
    title: strCode.LOCALISATIONS_TITLE
  },
  {
    id: 2,
    title: strCode.MARKETS_TITLE
  },
  {
    id: 3,
    title: strCode.ROLES_TITLE
  },
  {
    id: 4,
    title: strCode.CUSTOMIZE_EMAIL_TITLE
  }
];
